export interface FormattedMilesType {
  originalValue: number;
  formattedValue: string;
  error?: {
    message: string;
    maxMiles?: number;
    minMiles?: number;
  };
}

const MAX_MILES = Number.MAX_SAFE_INTEGER;
export const formatMiles = (
  miles: number,
  decimalPlaces: number = 0,
): FormattedMilesType => {
  if (typeof miles !== "number" || isNaN(miles)) {
    return {
      originalValue: miles,
      formattedValue: "0",
      error: {
        message: "commonErrors.invalidMiles.type",
      },
    };
  }
  if (miles < 0 || miles > MAX_MILES) {
    return {
      originalValue: miles,
      formattedValue: "0",
      error: {
        message: "commonErrors.invalidMiles.value",
        maxMiles: MAX_MILES,
        minMiles: 0,
      },
    };
  }
  if (!Number.isInteger(decimalPlaces) || decimalPlaces < 0) {
    return {
      originalValue: miles,
      formattedValue: "0",
      error: {
        message: "commonErrors.invalidMiles.decimalPlaces",
      },
    };
  }

  if (miles === 0)
    return {
      originalValue: miles,
      formattedValue: "0",
    };

  const formattedMiles = miles.toLocaleString("en-US", {
    minimumFractionDigits: decimalPlaces,
    maximumFractionDigits: decimalPlaces,
  });

  return {
    originalValue: miles,
    formattedValue: formattedMiles,
  };
};
